// import WOW from 'wow.js';
import SplitType from 'split-type';

export default {
    MOBILE_WIDTH: 768,
    DESKTOP_WIDTH: 1340,
    init() {
        this.preWOW();
    },
    preWOW() {
        let width = document.body.clientWidth;
        if(width > this.MOBILE_WIDTH && width < this.DESKTOP_WIDTH) {
            let header = document.querySelector('.header__text');
            if(header) {
                header.classList.add('wow', 'animate__animated', 'animate__slideInUp');
            }
        } else {
            this.splitHeader();
        }
        this.animateReels();
    },
    //splitting header into different lines.
    splitHeader() {
        // console.log("IX.js - Splitting header.");
        let header = document.querySelector('.header__text');
        if(header) {
            this.splitText(header, 'wow animate__animated animate__slideInUp', true)
        }
    },
    /**
     * @param {HTMLElement} el Element to apply
     * @param {string} animationClasses classes to apply for the line animations.
     */
    splitText(el, animationClasses, wrap = false, delay = 200, duration = 1000) {
        let options;

        if(!wrap) {
            options = {
                types: 'lines',
                lineClass: animationClasses
            }
        } else {
            options = {
                types: 'lines',
                lineClass: 'animation-wrapper'
            };
        }

        const text = new SplitType(el, options);

        if(text && text.lines) {
            text.lines.forEach((line, i) => {
                let text = line.innerText;
                if(!wrap) {
                    line.dataset.wowDuration = duration + 'ms';
                    line.dataset.wowDelay = (delay * i) + 'ms';
                }
                else {
                    let el = document.createElement('div');
                    el.innerText = text;
                    el.className = animationClasses;
                    el.dataset.wowDuration = duration + 'ms';
                    el.dataset.wowDelay = (delay * i) + 'ms';
                    line.innerText = "";
                    line.appendChild(el);
                }
            })
        }
    },
    animateReels() {
        let reels = document.querySelectorAll('.media-grid--reel');
        if(reels) {
            Array.from(reels).forEach(reel => {
                let video = reel.querySelector('video');
                if(video) {
                    let poster = video.getAttribute("poster");
                    //poster is present, in which case wait for it to load before doing the animation
                    if (poster && !this.isIOS()) {
                        let img = new Image();
                        img.src = poster;
                        img.onload = () => {
                            // console.log("IX.js - loaded poster");
                            video.classList.add('wow', 'animate__animated', 'animate__fadeInUp');
                            video.dataset.wowDuration = '1250ms';
                        }
                    }
                    //no poster is present, so just do the animation.
                    else {
                        video.classList.add('wow', 'animate__animated', 'animate__fadeInUp');
                        video.dataset.wowDuration = '1250ms';
                    }
                }
            })
        }
    },
    isIOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
}